<div class="modal-header">
  <button type="button" class="close" ng-click="cancel()">&times;</button>
  <h3 class="modal-title">Configurações</h3>
</div>
<div class="modal-body">
  <form name="form">
    <div class="form-group">
      <label for="widget-title" class="control-label">Título</label>
      <input type="text" class="form-control" name="widgetTitle" ng-model="settings.result.title">
    </div>
    <div class="form-group">
      <label class="control-label">Propriedade</label>
      <ui-select ng-model="settings.result.dataModelOptions.propriedade" theme="bootstrap" id="propriedade" name="propriedade" append-to-body="true">
        <ui-select-match placeholder="Propriedade atual ({{$root.currentPropriedade.descricao}})">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); settings.result.dataModelOptions.propriedade = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="propriedade in settings.result.data.propriedades | orderBy: 'descricao' | filter: $select.search track by propriedade.id">
          <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="row">
      <div class="col-xs-6">
        <div class="form-group">
          <label class="control-label">Data inicial</label>
          <div class="input-group">
            <input type="text"
                   class="form-control"
                   uib-datepicker-popup="dd/MM/yyyy"
                   ng-model="settings.result.dataModelOptions.dataInicial"
                   show-weeks="false"
                   is-open="settings.datepickerInicialOpen"
                   ng-change="settings.notInterval()">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" ng-click="settings.toggleInitialDatepicker()">
                <i class="glyphicon glyphicon-calendar"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-6">
        <div class="form-group">
          <label class="control-label">Data final</label>
          <div class="input-group">
            <input type="text"
                   class="form-control"
                   uib-datepicker-popup="dd/MM/yyyy"
                   ng-model="settings.result.dataModelOptions.dataFinal"
                   show-weeks="false"
                   is-open="settings.datepickerFinalOpen"
                   ng-change="settings.notInterval()">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" ng-click="settings.toggleEndDatepicker()">
                <i class="glyphicon glyphicon-calendar"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="btn-group">
          <button type="button"
                  class="btn btn-white"
                  ng-click="settings.set15DaysAgo()">15 dias</button>
          <button type="button"
                  class="btn btn-white"
                  ng-click="settings.set30DaysAgo()">30 dias</button>
          <button type="button"
                  class="btn btn-white"
                  ng-click="settings.set60DaysAgo()">60 dias</button>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="settings.cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="settings.ok()">OK</button>
</div>
